<template>
    <tr>
        <td>{{ user.last_name }}</td>
        <td>{{ user.first_name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ roles }}</td>
        <td nowrap>
            <span style="overflow: visible; position: relative; width: 110px;">
                <div class="dropdown" style="display: inline-block;">
                    <a href="#" class="btn btn-success btn-elevate btn-sm btn-circle btn-icon" data-toggle="dropdown">
                        <i class="la la-ellipsis-h"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a @click.prevent.stop="setIndex({ name: 'editIndex', value: index })" href="#" class="dropdown-item" title="Edit details">
                            <i class="la la-eye"></i>{{ labels.modify_user }}
                        </a>
                        <a @click.prevent="triggerDeleteUser" href="#" class="dropdown-item" title="Delete">
                            <i class="la la-trash"></i>{{ labels.delete_user }}
                        </a>
                    </div>
                </div>
            </span>
        </td>
    </tr>
</template>

<script>
// 3rd party dependencies
import { mapState, mapActions } from 'vuex'
import { HTTP } from '../../assets/js/axiosConfig'
// Mixins
import AlertAction from '../../assets/js/mixins'

const timer = 3000
export default {
    props: ['user', 'index'],
    mixins: [AlertAction],
    computed: {
        ...mapState({
            labels: store => store.labels,
            users: store => store.users.users,
            results: store => store.users.results
        }),
        roles () {
            return this.user.roles.join(', ')
        }
    },
    methods: {
        ...mapActions('users', [
            'setIndex',
            'updateUserList'
        ]),
        triggerDeleteUser () {
            this.alertAction(this.deleteUserRequest, 'delete_user_warning')
        },
        deleteUserRequest () {
            HTTP.delete(`api/users/${this.user.user_id}`)
                .then(() => {
                    // Alert on success
                    this.sweetAlert('success', this.labels.user_deleted_success, timer)
                    // Update list data
                    this.updateUserList({ action: 'DELETE', index: this.index })
                })
                .catch(err => {
                    console.log(err)
                    this.sweetAlert('error', this.labels.error_delete_user, timer)
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Users/UserRow.vue